import script from "./PatientDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__